/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Company } from '../../models/company';
import { CreateDistributorDto } from '../../models/create-distributor-dto';

export interface CreateOneBaseMgmtDistributorControllerCompany$Params {
      body: CreateDistributorDto
}

export function createOneBaseMgmtDistributorControllerCompany(http: HttpClient, rootUrl: string, params: CreateOneBaseMgmtDistributorControllerCompany$Params, context?: HttpContext): Observable<StrictHttpResponse<Company>> {
  const rb = new RequestBuilder(rootUrl, createOneBaseMgmtDistributorControllerCompany.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Company>;
    })
  );
}

createOneBaseMgmtDistributorControllerCompany.PATH = '/api/mgmt/distributors';
